
export enum TemperatureControlEnum {
  NONE = 'NONE',
}
